import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const refreshBeforeExpiry = 300;   // seconds before key expiration that we will initiate an auth refresh

export class OAuthKey {
    host: string;
    secureHost: boolean;
    clientID: string;
    clientSecret: string;
    scope?: string;
    bearer?: string;
    expiresAt: number;
    timestamp: number;
    timeoutTimer?: number;
    authorization?: string;
    refreshes: number = 0;
    ldapEnabled: boolean = false;

    resolveUrl(url: string) {
        if (url && url.length > 0 && url[0] === '/')
            url = url.substring(1);
        return (this.secureHost ? 'https' : 'http') + '://' + this.host + '/' + url;
    }

    ageInSeconds(): number {
        return (Math.floor(Date.now() / 1000) - this.timestamp);
    }

    humanAge() {
        let age = this.ageInSeconds();
        if (age < 60)
            return age + 's';
        else if (age < 3600)
            return Math.round(age / 60) + 'm';
        else
            return Math.round(age / 3600) + 'h ' + Math.round((age % 3600) / 60) + 'm';
    }

    secondsUntilExpired() {
        const timestamp = Math.floor(Date.now() / 1000);
        return (this.expiresAt && !isNaN(this.expiresAt))
            ? ((this.expiresAt > timestamp) ? this.expiresAt - timestamp : 0)   // returns 0 if already past expiry
            : 7 * 86400; // essentially infinite
    }

    expire() {
        if (this.timeoutTimer) {
            window.clearTimeout(this.timeoutTimer);
            this.timeoutTimer = undefined;
        }
        this.bearer = undefined;
        // console.log("expiring ", this);
    }

    expired(): boolean {
        return this.secondsUntilExpired() <= 0;  // consider expired after 55 mins
    }

    expiring(withinSeconds?: number): boolean {
        if (withinSeconds === undefined) withinSeconds = refreshBeforeExpiry;
        return this.secondsUntilExpired() < withinSeconds;
    }

    setRefreshTimer(callback: (key: OAuthKey) => void, seconds?: number) {
        if (this.timeoutTimer)
            window.clearTimeout(this.timeoutTimer);
        if (seconds === undefined)
            seconds = this.secondsUntilExpired() - refreshBeforeExpiry;
        if (!isNaN(seconds)) {
            if (seconds < 120) seconds = 120;    // guard
            this.timeoutTimer = window.setTimeout(
                () => callback(this),
                seconds * 1000    // set to refresh a few mins before expiry
            );
        }
    }

    isLdapEnabled(): boolean {
        let url = 'http://default/api/config/ldap/enableLdap';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    return response.data.value;
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('expected enableLdap response, got ', response.data);
                    return false;
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('isLdapEnabled() error: ', error);
                return false;
            });
        return false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/oauth-key.tsx